import { useState } from 'react';

import {
  SmartApplyApiError,
  authPasswordResetRequest,
} from '../lib/api-client.js';
import { AuthLayout } from '../components/auth/AuthLayout.js';

export function ForgotPasswordRoute() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await authPasswordResetRequest({ email });
      setSent(true);
    } catch (err) {
      setError(err instanceof SmartApplyApiError ? err.message : 'Falha ao processar.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Esqueci a senha"
      subtitle="Te mandamos um link por e-mail. O link vale por 1 hora e só pode ser usado uma vez."
      badge="recovery"
    >
      {sent ? (
        <div className="card-paper rounded-sm px-7 py-7" style={{ borderLeft: '3px solid var(--accent-forest)' }}>
          <p className="font-serif text-lg text-[var(--ink-primary)]">
            Se o e-mail existe, enviamos o link.
          </p>
          <p className="mt-3 font-sans text-sm text-[var(--ink-secondary)]">
            Confira sua caixa de entrada (e o spam). Em modo de desenvolvimento, o link aparece
            no console da API ao invés de ser enviado por SMTP.
          </p>
          <a
            href="#/login"
            className="mt-6 inline-block font-sans text-sm text-[var(--ink-secondary)] underline-offset-4 hover:underline"
          >
            ← voltar pra login
          </a>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="card-paper rounded-sm px-7 py-7" style={{ borderLeft: '3px solid var(--accent-saffron)' }}>
          <div className="space-y-5">
            <div>
              <label
                htmlFor="email"
                className="block font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]"
              >
                E-mail da conta
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full rounded-sm border border-[var(--border-default)] bg-[var(--bg-paper)] px-3 py-2 font-mono text-sm text-[var(--ink-primary)] focus:border-[var(--accent-saffron)] focus:outline-none"
              />
            </div>

            {error && (
              <div className="rounded-sm border border-[var(--accent-crimson-border)] bg-[var(--accent-crimson-bg)] px-4 py-2.5">
                <p className="font-sans text-sm text-[var(--accent-crimson)]">{error}</p>
              </div>
            )}

            <div className="flex items-center justify-between">
              <a
                href="#/login"
                className="font-sans text-xs text-[var(--ink-tertiary)] underline-offset-4 hover:underline"
              >
                ← voltar pra login
              </a>
              <button
                type="submit"
                disabled={loading || !email}
                className="rounded-sm bg-[var(--ink-primary)] px-5 py-2 font-sans text-sm text-[var(--bg-paper)] transition-opacity hover:opacity-90 disabled:opacity-40"
              >
                {loading ? 'Enviando...' : 'Enviar link'}
              </button>
            </div>
          </div>
        </form>
      )}
    </AuthLayout>
  );
}
